import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSparks } from '../../contexts/SparksContext';
import { readTally } from './recapTally';
import SparksStarsClimb from './SparksStarsClimb';
import useSparksStarsClimb from './useSparksStarsClimb';
import { useShop } from './useCosmeticCatalogue';

/**
 * The Sparks Stars climb on its own, for screens partway through a lesson (lesson finished, pre-quiz missed).
 * The tally stays open so the end-of-lesson recap still counts everything; only its starting board moves on.
 */
export default function SparksStarsUpdate() {
  const { loggedInChild } = useAuth();
  const childId = loggedInChild?._id;
  const { enabled } = useSparks();
  const shop = useShop(enabled ? childId : null);
  const [tally] = useState(() => readTally(childId));
  const { climb } = useSparksStarsClimb(childId, tally, { rebase: true });

  if (!climb) return null;
  return (
    <div className="w-full max-w-sm mx-auto mb-4" data-testid="sparks-stars-update">
      <SparksStarsClimb key={`${climb.kind}-${climb.to}-${climb.by}`} climb={climb} catalogue={shop?.items} />
    </div>
  );
}
